import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal, Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  stucategorylist,
  stufeetypelist,
  feetypemappinglist,
  feetypemappingcreate,
  feetypemappingupdate,
  feetypemappingdelete,
  feetypemappingdetail,
} from "../../../services/master";
import { academylist } from "../../../services/admin";

export const FeeTypeMapping = () => {
  const isSuperAdmin = localStorage.getItem("Role") === "1";

  const [filterProduct, setFilterProduct] = useState([]);
  const [mapId, setMapId] = useState(0);
  const [catlist, setCatList] = useState([]);
  const [ftlist, setFtList] = useState([]); // [{id, fee_type}]
  const [selectedCat, setSelectedCat] = useState([]); // array of category options
  const [checkedTypes, setCheckedTypes] = useState([]); // array of feetype ids (strings)
  const [errorMessage, setErrorMessage] = useState("");
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isSuperAdmin) {
      academylist().then((res) => {
        if (res.status === true && res.data.details.length > 0) {
          const opts = res.data.details.map((d) => ({
            value: d.id,
            label: d.name + " - " + d.code,
          }));
          setAList(opts);
          // Default to the user's assigned academy, like the other masters.
          const aa = localStorage.getItem("AAcademy");
          if (aa != null) {
            const def = opts.find((o) => String(o.value) === String(aa));
            if (def) {
              setAcaID(def);
              loadFeeTypes(def);
            }
          }
        }
      });
    }
    stucategorylist().then((res) => {
      if (res.status === true) {
        setCatList(
          (res.data || []).map((c) => ({ value: c.id, label: c.cat_name }))
        );
      }
    });
    loadFeeTypes("");
    funlist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function loadFeeTypes(aid) {
    const temp = new FormData();
    if (isSuperAdmin && aid !== "") temp.append("academy_id", aid.value);
    return stufeetypelist(temp).then((res) => {
      if (res.status === true) {
        setFtList(res.data || []);
        return res.data || [];
      }
      return [];
    });
  }

  function funlist() {
    setFilterProduct([]);
    const temp = new FormData();
    feetypemappinglist(temp).then((res) => {
      if (res.status === true) setFilterProduct(res.data || []);
    });
  }

  const columnDefs = [
    {
      headerName: "Category",
      field: "cat_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Fee Types",
      field: "feetype_names",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      flex: 1,
      cellStyle: { textAlign: "left" },
    },
    ...(isSuperAdmin
      ? [
          {
            headerName: "Academy",
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
          },
        ]
      : []),
    {
      headerName: "Actions",
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewshow(params.value)}
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>
            <a
              onClick={() => handleDelete(params.value)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash"></i>
            </a>
          </div>
        );
      },
    },
  ];

  function handleshow() {
    setMapId(0);
    setSelectedCat([]);
    setErrorMessage("");
    // Default to the assigned academy (AAcademy) like the other masters.
    const aa = localStorage.getItem("AAcademy");
    const def =
      isSuperAdmin && aa != null
        ? alist.find((o) => String(o.value) === String(aa)) || ""
        : "";
    setAcaID(def);
    // Default: all feetypes ticked.
    loadFeeTypes(def).then((types) => {
      setCheckedTypes(types.map((t) => String(t.id)));
    });
    setShow(true);
  }

  function handleclose() {
    setMapId(0);
    setSelectedCat([]);
    setAcaID("");
    setCheckedTypes([]);
    setErrorMessage("");
    setShow(false);
  }

  function handleAcademy(e) {
    setAcaID(e || "");
    loadFeeTypes(e || "").then((types) => {
      // Re-default to all when academy changes (only on a fresh add).
      if (mapId === 0) setCheckedTypes(types.map((t) => String(t.id)));
    });
  }

  function viewshow(id) {
    setMapId(id);
    setErrorMessage("");
    feetypemappingdetail(id).then((res) => {
      if (res.status === true && res.data) {
        // Load the feetype checkboxes for the mapping's own academy.
        const acaOpt = isSuperAdmin
          ? alist.find((o) => String(o.value) === String(res.data.academy_id)) ||
            ""
          : "";
        setAcaID(acaOpt);
        loadFeeTypes(acaOpt).then(() => {
          const cat = catlist.find((c) => c.value === res.data.category_id);
          setSelectedCat([cat || { value: res.data.category_id, label: "" }]);
          const ids = String(res.data.feetypes || "")
            .split(",")
            .map((x) => x.trim())
            .filter((x) => x !== "");
          setCheckedTypes(ids);
          setShow(true);
        });
      }
    });
  }

  function toggleType(id) {
    const sid = String(id);
    setCheckedTypes((prev) =>
      prev.includes(sid) ? prev.filter((x) => x !== sid) : [...prev, sid]
    );
  }

  function handleDelete(id) {
    Swal.fire({
      text: "Are you sure want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const temp = new FormData();
        temp.append("id", id);
        feetypemappingdelete(temp).then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            funlist();
          }
        });
      }
    });
  }

  function Submit() {
    setErrorMessage("");
    if (isSuperAdmin && acaid === "") {
      setErrorMessage("Please Select Academy");
      return;
    }
    if (!selectedCat || selectedCat.length === 0) {
      setErrorMessage("Please Select Category");
      return;
    }
    if (checkedTypes.length === 0) {
      setErrorMessage("Please select at least one Fee Type");
      return;
    }
    const temp = new FormData();
    temp.append("feetypes", checkedTypes.join(","));
    temp.append("user_id", localStorage.getItem("UID"));
    if (isSuperAdmin && acaid !== "") temp.append("academy_id", acaid.value);

    if (mapId === 0) {
      // Many categories -> backend stores one row per category.
      temp.append("category_ids", selectedCat.map((c) => c.value).join(","));
      feetypemappingcreate(temp).then((res) => {
        if (res.status === true) {
          handleclose();
          funlist();
          toast.success(res.message);
        } else {
          setErrorMessage(res.message);
        }
      });
    } else {
      // Editing a single existing row.
      temp.append("id", mapId);
      temp.append("category_id", selectedCat[0].value);
      feetypemappingupdate(temp).then((res) => {
        if (res.status === true) {
          handleclose();
          funlist();
          toast.success(res.message);
        } else {
          setErrorMessage(res.message);
        }
      });
    }
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">FeeType Mapping</h2>
        </div>
      </div>
      <Row className="row-sm mx-0 mt-3">
        <Col xxl={12} lg={12} md={12}>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <div className="res-right">
                  <a
                    onClick={handleshow}
                    type="button"
                    className="btn my-1 me-2 btn-success tx-teko"
                  >
                    Add
                  </a>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>

              <Modal show={show} size="lg">
                <Modal.Header>
                  {mapId === 0 ? (
                    <h4>Add FeeType Mapping</h4>
                  ) : (
                    <h4>Edit FeeType Mapping</h4>
                  )}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    {isSuperAdmin && (
                      <Col lg={12} md={12} className="mb-3">
                        <label className="mb-2">
                          Select Academy<span className="text-danger"> *</span>
                        </label>
                        <Select
                          className="default-select"
                          placeholder="Select Academy"
                          value={acaid}
                          options={alist}
                          onChange={handleAcademy}
                          isSearchable={true}
                          isClearable
                          hidden
                        />
                      </Col>
                    )}

                    <Col lg={12} md={12} className="mb-3">
                      <label className="mb-2">
                        Category<span className="text-danger"> *</span>
                      </label>
                      <Select
                        isMulti
                        className="default-select"
                        placeholder="Select Category"
                        value={selectedCat}
                        options={catlist}
                        onChange={(v) => setSelectedCat(v || [])}
                        isSearchable={true}
                        classNamePrefix="select"
                      />
                    </Col>

                    <Col lg={12} md={12}>
                      <label className="mb-2">
                        Fee Types<span className="text-danger"> *</span>{" "}
                        {/* <span className="text-muted tx-12">
                          (all ticked by default — untick to exclude)
                        </span> */}
                      </label>
                      <div className="d-flex flex-wrap" style={{ gap: "8px 18px" }}>
                        {ftlist.length === 0 ? (
                          <span className="text-muted tx-12">
                            No fee types found.
                          </span>
                        ) : (
                          ftlist.map((t) => (
                            <label
                              key={t.id}
                              style={{ cursor: "pointer", minWidth: "150px" }}
                            >
                              <input
                                type="checkbox"
                                className="styled-checkbox"
                                checked={checkedTypes.includes(String(t.id))}
                                onChange={() => toggleType(t.id)}
                              />{" "}
                              {t.fee_type}
                            </label>
                          ))
                        )}
                      </div>
                    </Col>

                    {errorMessage !== "" && (
                      <span className="text-danger mt-2">{errorMessage}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <a
                    onClick={Submit}
                    className="btn btn-next btn-success"
                    style={{ float: "right" }}
                  >
                    {mapId === 0 ? "Submit" : "Update"}
                  </a>
                  <a
                    className="btn btn-next btn-secondary"
                    style={{ float: "right" }}
                    onClick={handleclose}
                  >
                    Close
                  </a>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};
